import type { SVGProps } from 'react';
const SvgDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M6.142 1.018c-.03.01-.11.05-.178.086-.402.212-.69.599-.781 1.05-.026.127-.03.194-.03.62v.477l-1.849.004c-1.726.004-1.854.006-1.922.029a.8.8 0 0 0-.315.226L1 3.594v.636l.062.082c.076.1.135.148.257.205l.094.045.583.004c.322.002.584.008.584.008 0 .012.757 9.07.764 9.137.013.137.07.346.13.473.152.332.4.584.728.745L4.35 15h7.29l.16-.08c.43-.215.715-.585.822-1.069.017-.076.03-.225.47-5.506.165-1.988.304-3.65.309-3.695l.008-.08 1.165-.008.105-.05a.7.7 0 0 0 .277-.24L15 4.207V3.89c0-.173-.005-.314-.011-.312-.007.002-.04-.031-.074-.074a.8.8 0 0 0-.31-.22c-.069-.023-.198-.025-1.923-.029l-1.85-.004v-.477c0-.426-.003-.493-.029-.62a1.53 1.53 0 0 0-.821-1.07l-.16-.08L8.01 1c-1.532-.003-1.822 0-1.867.017m.44 1.25a.3.3 0 0 0-.078.064c-.027.037-.029.06-.033.48l-.004.44H9.52l-.004-.44c-.004-.42-.006-.443-.033-.48a.3.3 0 0 0-.077-.064c-.045-.023-.141-.025-1.412-.025s-1.367.002-1.412.025M1.005 3.91c0 .182.002.256.004.165.003-.09.003-.239 0-.33-.002-.09-.004-.016-.004.165m2.899.712.376 4.507c.4 4.813.372 4.53.459 4.595l.038.029h6.43l.038-.029c.087-.065.059.219.46-4.602.204-2.462.373-4.49.376-4.507l.005-.032H3.9z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDelete;
